import { render } from "./DownloadFiles.vue?vue&type=template&id=d48a293a&scoped=true&ts=true"
import script from "./DownloadFiles.vue?vue&type=script&lang=ts"
export * from "./DownloadFiles.vue?vue&type=script&lang=ts"

import "./DownloadFiles.vue?vue&type=style&index=0&id=d48a293a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48a293a"]])

export default __exports__